import { CopyOutlined } from '@ant-design/icons'
import { App, Button, theme, Tooltip } from 'antd'

export const CopyButton = ({ textToCopy }: { textToCopy: string }) => {
    const { message } = App.useApp()
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy)
            message.success('Текст скопирован!')
        } catch {
            message.error('Не удалось скопировать текст.')
        }
    }

    const {
        token: { colorPrimary }
    } = theme.useToken()

    return (
        <Tooltip title="Копировать">
            <Button
                type="text"
                style={{ color: colorPrimary }}
                size="small"
                onClick={handleCopy}
                icon={<CopyOutlined />}
            />
        </Tooltip>
    )
}
